export default __webpack_public_path__ + "static/media/knee.5450ed89.svg";